import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {FilterLinkListComponent} from '../filter-link-list/filter-link-list.component';
import {FiltersGameListPcBox} from "./boxes/filters-game-list-pc.box";
import {
  IArenaGameFilterEditorViewModel
} from "../../../services/games-filter/arena-filters/filters/arena-game-filter-editor-view-model.interface";
import {
  ISimpleStrategyFiltersEditorViewModel
} from "../../../services/games-filter/strategies/simple-games-filter/simple-strategy-filters-editor-view-model.interface";


interface FiltersGamesListPcComponentProps {
  filtersEditor: ISimpleStrategyFiltersEditorViewModel;
}
@observer
export class FiltersGamesListPcComponent extends OrbitComponent<FiltersGamesListPcComponentProps> {


  private _toggleFilter = async (filter: IArenaGameFilterEditorViewModel) => {
    filter.toggleFilter();
    await this.props.filtersEditor.applyFilters();
    this.services.analytics.sendOrbitUserFlowEvent("Navigation",this.services.routing.currentRoute.data.arenaType, filter.id);
  };

  render() {

    if(this.props.filtersEditor.visibleFilters.length === 0) {
      return null;
    }

    return (
      <FiltersGameListPcBox className={'cy-filters-game-list-pc'}>
          <FilterLinkListComponent filters={this.props.filtersEditor.visibleFilters} onToggle={this._toggleFilter} />
      </FiltersGameListPcBox>
    );
  }
}
